import $ from "jquery";

$(function() {
    $(".bl-introanimation").each(function() {
        const $bl = $(this);
        const $mainillu = $bl.find(".mainillu");
        const $indicator = $mainillu.find(".indicator");
        const $ctrillu = $bl.find(".ctrillu");
        const $ctrinfo = $bl.find(".ctrinfo");
        const $video = $bl.find(".circlevideo");
        const $prevideo = $bl.find(".prevideo");
        
        const indicatorAngle1 = degToRad(37);
        const indicatorAngle2 = degToRad(107);
        const indicatorAngle3 = degToRad(180);
        const indicatorAngle4 = degToRad(253);
        const indicatorAngle5 = degToRad(323);

        setTimeout(playPreVideo, 500);

        function playPreVideo() {
            const video = $prevideo.get(0);
            video.play();
            function onVideoEnd() {
                $prevideo.addClass("hidden");
                makeVisible();
            }
            video.addEventListener("ended", onVideoEnd);

            setTimeout(function() {
                if(video.currentTime == 0) {
                    //unable to play. fallback. (low power mode on iPhone)
                    onVideoEnd();
                }
            }, 2000);
        }

        function makeVisible() {
            $mainillu.removeClass("invisible");
            setTimeout(showButtons, 250);
        }
        function showButtons() {
            $mainillu.removeClass("buttonshidden");
            setTimeout(startInitialHighlight, 500);
        }

        function startInitialHighlight() {
            $mainillu.find(".p1-gbtn").addClass("active");
            setTimeout(function() {
                moveIndicator(indicatorAngle2);
                setTimeout(function() {
                    $mainillu.find(".p2-gbtn").addClass("active");
                }, 500);
            }, 500);
            setTimeout(function() {
                moveIndicator(indicatorAngle3);
                setTimeout(function() {
                    $mainillu.find(".p3-gbtn").addClass("active");
                }, 500);
            }, 1500);
            setTimeout(function() {
                moveIndicator(indicatorAngle4);
                setTimeout(function() {
                    $mainillu.find(".p4-gbtn").addClass("active");
                }, 500);
            }, 2500);
            setTimeout(function() {
                moveIndicator(indicatorAngle5);
                setTimeout(function() {
                    $mainillu.find(".p5-gbtn").addClass("active");
                }, 500);
            }, 3500);
            setTimeout(finishInitialHighlight, 4500);
        }
        function finishInitialHighlight() {
            moveIndicator(indicatorAngle1+2*Math.PI);
            $indicator.fadeOut(500);
            //$mainillu.find(".p-btn, .p-text").css("transition-duration", "1s");
            $mainillu.find(".p1-gbtn").removeClass("active");
            setTimeout(function() { $mainillu.find(".p2-gbtn").removeClass("active"); }, 200);
            setTimeout(function() { $mainillu.find(".p3-gbtn").removeClass("active"); }, 400);
            setTimeout(function() { $mainillu.find(".p4-gbtn").removeClass("active"); }, 600);
            setTimeout(function() { $mainillu.find(".p5-gbtn").removeClass("active"); }, 800);

            setTimeout(function() {
                setIndicator(degToRad(0));
            }, 1000);
            setTimeout(initEvents, 1000);
        }

        function autoClickFirstButton() {
            $mainillu.find(".p1-gbtn").trigger("click");
        }

        function initEvents() {
            let firstClick = true;
            $mainillu.on("click", ".p-gbtn", function() {
                const $gbtn = $(this);
                $mainillu.find(".p-gbtn").removeClass("active");
                $ctrillu.removeClass("hcenter");

                if(firstClick) {
                    $indicator.fadeIn(500);

                    $video.removeClass("invisible");

                    setTimeout(function() {
                        $ctrinfo.removeClass("invisible");
                    }, 500);
                }

                if($gbtn.hasClass("p1-gbtn")) { activateButton(1, firstClick); }
                if($gbtn.hasClass("p2-gbtn")) { activateButton(2, firstClick); }
                if($gbtn.hasClass("p3-gbtn")) { activateButton(3, firstClick); }
                if($gbtn.hasClass("p4-gbtn")) { activateButton(4, firstClick); }
                if($gbtn.hasClass("p5-gbtn")) { activateButton(5, firstClick); }

                firstClick = false;
            });
            setTimeout(autoClickFirstButton, 100);
            setTimeout(showArosaButton, 2000);
        }

        function activateButton(buttonNum, firstClick) {
            $mainillu.find(".p"+buttonNum+"-gbtn").addClass("active");
            if(buttonNum == 1) { moveIndicator(indicatorAngle1); }
            if(buttonNum == 2) { moveIndicator(indicatorAngle2); }
            if(buttonNum == 3) { moveIndicator(indicatorAngle3); }
            if(buttonNum == 4) { moveIndicator(indicatorAngle4); }
            if(buttonNum == 5) { moveIndicator(indicatorAngle5); }

            function updateText() {
                $ctrinfo.html($bl.find(".texttpl"+buttonNum).html());
            }
            function playVideo() {
                const video = $video.get(0);
                if(buttonNum == 1) {
                    video.src = "/assets/Dateien/Phasen/projektidee.mp4";
                } else if(buttonNum == 2) {
                    video.src = "/assets/Dateien/Phasen/vorphase.mp4";
                } else if(buttonNum == 3) {
                    video.src = "/assets/Dateien/Phasen/planungsphase.mp4";
                } else if(buttonNum == 4) {
                    video.src = "/assets/Dateien/Phasen/realisationsphase.mp4";
                } else if(buttonNum == 5) {
                    video.src = "/assets/Dateien/Phasen/betriebsphase.mp4";
                }
                video.play();
            }

            playVideo();

            if(firstClick) {
                updateText();
            } else {
                playAnimation($ctrinfo, "introanimation-textswitch-out", {
                    "callback": function() {
                        updateText();
                        playAnimation($ctrinfo, "introanimation-textswitch-in");
                    }
                });
            }
        }

        let currentIndicatorAngle = undefined;
        setIndicator(indicatorAngle1);
        function setIndicator(newAngle) {
            currentIndicatorAngle = newAngle;

            const centerX = 540;
            const centerY = 540;
            const radius = 306;
            const indicatorX = centerX+radius*Math.cos(newAngle);
            const indicatorY = centerX+radius*Math.sin(newAngle);
            $indicator.attr({
                "cx": indicatorX,
                "cy": indicatorY
            });
        }
        function moveIndicator(newAngle) {
            const animObj = {angle:currentIndicatorAngle};
            $(animObj).animate({angle:newAngle}, {
                duration: 500,
                step: function(now) {
                    setIndicator(now);
                }
            });
        }

        function showArosaButton() {
            const $ctabutton = $bl.find(".ctabutton");
            $ctabutton.addClass("visible");
        }
    });
});

const oneDegInRad = 2*Math.PI/360;
function degToRad(angleDeg) {
    return (angleDeg-90)*oneDegInRad;
}

function playAnimation($p, animname, options)
{
	if(!options) {
		options = {};
	}
	$p.off("animationend").one("animationend", function() {
		$p.css("animation-name", "");
		if(options.hideOnEnd) {
			if($p.hasClass("visible")) {
				$p.removeClass("visible");
				$p.addClass("hidden");
			} else {
				$p.hide();
			}
		}
		if(options.callback) {
			options.callback($p);
		}
	});
	if(options.forceRestart) {
		$p.css("animation-name", "");
		$p.get(0).offsetHeight; //trigger reflow
	}
	$p.css("animation-name", animname);
	if(options.showOnStart) {
		if($p.hasClass("hidden")) {
			$p.removeClass("hidden");
			$p.addClass("visible");
		} else {
			$p.show();
		}
	}
}